// extracted by mini-css-extract-plugin
export var infoItem = "_t3-2";
export var title = "_t3-0";
export var value = "_t3-1";